import React from 'react';
import Button from './Button';
import { Upload } from 'lucide-react';
import { useI18n } from '../../context/I18nContext';

interface ImportButtonProps {
  onImport: () => void;
  className?: string;
  disabled?: boolean;
}

const ImportButton: React.FC<ImportButtonProps> = ({
  onImport,
  className = '',
  disabled = false
}) => {
  const { t } = useI18n();

  return (
    <Button
      variant="outline"
      onClick={onImport}
      icon={<Upload className="w-4 h-4" />}
      className={className}
      disabled={disabled}
    >
      {t('common.import')}
    </Button>
  );
};

export default ImportButton;
















